import React from "react";
import style from "../styles/Header.module.css";
const Header = () => {
  return (
    <div className={style.header}>
      <h1>Pseudoku</h1>
    </div>
  );
};

export default Header;
